"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseEndpointMessageOut = void 0;
class ListResponseEndpointMessageOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseEndpointMessageOut.attributeTypeMap;
    }
}
exports.ListResponseEndpointMessageOut = ListResponseEndpointMessageOut;
ListResponseEndpointMessageOut.discriminator = undefined;
ListResponseEndpointMessageOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<EndpointMessageOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseEndpointMessageOut.js.map